define("shared/components/shared/post/secondary/caption-writer/form", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "shared/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _generateCaptions, _clearForm;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <form class="tCW--form" data-test-id="caption-writer-form" onsubmit={{this.onSubmitForm}}>
    {{#unless @skipTopic}}
      <div class="u--m__b">
        <p class="u--text--bold u--m__b__xs">
          {{t "caption_writer.form.prompt_header"}}
        </p>
        <Textarea
          @value={{@generatedCaptionChangeset.topic}}
          aria-label={{t "caption_writer.enter_topic"}}
          class={{concat-classes
            "tCW--form__textarea"
            "qa--aiCaptions_txtBox"
            (if this.topicValidationError "has--error qa--error_border")
          }}
          data-test-id="caption-writer-form-topic-input"
          disabled={{this.isFormDisabled}}
          placeholder={{t "caption_writer.input_placeholder"}}
          {{autofocus}}
          {{autoresize}}
        />
        {{#if this.topicValidationError}}
          <p
            class="tCW--form__helperText--error qa--error_inline_warning qa--error_border"
            data-test-id="caption-writer-input-errors"
          >
            {{t this.topicValidationError}}
          </p>
        {{/if}}
      </div>
    {{/unless}}
  
    <div>
      <fieldset class="u--m__b__xs">
        <legend class="u--text--bold">
          {{t (if @skipTopic "caption_writer.form.tone_header" "caption_writer.form.tone_header_optional")}}
        </legend>
      </fieldset>
  
      <div class="tCW--radioBtnGroup">
        {{#each this.tones as |tone|}}
          {{#let (and this.selectedTone (eq this.selectedTone.value tone.value)) as |isSelected|}}
            <div
              class={{concat-classes
                "tCW--radioBtn"
                tone.qaClass
                (if isSelected "is--selected")
                (if this.isFormDisabled "is--disabled")
              }}
            >
              <input
                checked={{isSelected}}
                disabled={{this.isFormDisabled}}
                id={{tone.value}}
                name="tone"
                type="radio"
                value={{tone.value}}
                {{on "click" (fn this.onSelectTone tone)}}
              />
              <label for={{tone.value}}>
                {{svg-jar tone.icon class="o--icon"}}
                <span>
                  {{tone.label}}
                </span>
                {{svg-jar "verified-solid" class="o--icon o--icon--hl"}}
              </label>
            </div>
          {{/let}}
        {{/each}}
      </div>
    </div>
  
    {{#if this.isCustomToneSelected}}
      <Input
        @value={{@generatedCaptionChangeset.tone}}
        class={{concat-classes
          "o--form__input"
          "tCW--form__input"
          "qa--aiCaptions_tone_txtBox"
          (if this.toneValidationError "has--error qa--error_border")
        }}
        data-test-id="caption-writer-form-custom-tone-input"
        disabled={{this.isFormDisabled}}
        id="customTone"
        name="customTone"
        placeholder={{t "caption_writer.form.tone_placeholder"}}
        {{autofocus}}
      />
      {{#if this.toneValidationError}}
        <p
          class="tCW--form__helperText--error qa--error_inline_warning qa--error_border"
          data-test-id="caption-writer-form-custom-tone-input-error"
        >
          {{t this.toneValidationError}}
        </p>
      {{/if}}
    {{/if}}
  
    <Shared::Ui::Button
      @additional="rounded"
      @class={{concat-classes
        "o--btn--block"
        "u--m__t__md"
        "qa--aiCaptions_createBtn"
        (if this.isSubmitButtonDisabled "qa--aiCaptions_createBtn_disabled")
      }}
      @isDisabled={{this.isSubmitButtonDisabled}}
      data-test-id="caption-writer-form-submit"
      type="submit"
    >
      <span class="u--m__r__xs">{{t "caption_writer.button_cta"}}</span>
      {{svg-jar "ai" class="o--icon"}}
    </Shared::Ui::Button>
  </form>
  */
  {
    "id": "AdKyjssW",
    "block": "[[[10,\"form\"],[14,0,\"tCW--form\"],[14,\"data-test-id\",\"caption-writer-form\"],[15,\"onsubmit\",[30,0,[\"onSubmitForm\"]]],[12],[1,\"\\n\"],[41,[51,[30,1]],[[[1,\"    \"],[10,0],[14,0,\"u--m__b\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold u--m__b__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"caption_writer.form.prompt_header\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,2],[[16,\"aria-label\",[28,[37,1],[\"caption_writer.enter_topic\"],null]],[16,0,[28,[37,3],[\"tCW--form__textarea\",\"qa--aiCaptions_txtBox\",[52,[30,0,[\"topicValidationError\"]],\"has--error qa--error_border\"]],null]],[24,\"data-test-id\",\"caption-writer-form-topic-input\"],[16,\"disabled\",[30,0,[\"isFormDisabled\"]]],[16,\"placeholder\",[28,[37,1],[\"caption_writer.input_placeholder\"],null]],[4,[38,5],null,null],[4,[38,6],null,null]],[[\"@value\"],[[30,2,[\"topic\"]]]],null],[1,\"\"],[41,[30,0,[\"topicValidationError\"]],[[[1,\"        \"],[10,2],[14,0,\"tCW--form__helperText--error qa--error_inline_warning qa--error_border\"],[14,\"data-test-id\",\"caption-writer-input-errors\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[30,0,[\"topicValidationError\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[12],[1,\"\\n    \"],[10,\"fieldset\"],[14,0,\"u--m__b__xs\"],[12],[1,\"\\n      \"],[10,\"legend\"],[14,0,\"u--text--bold\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[52,[30,1],\"caption_writer.form.tone_header\",\"caption_writer.form.tone_header_optional\"]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tCW--radioBtnGroup\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"tones\"]]],null]],null],null,[[[44,[[28,[37,10],[[30,0,[\"selectedTone\"]],[28,[37,11],[[30,0,[\"selectedTone\",\"value\"]],[30,3,[\"value\"]]],null]],null]],[[[1,\"          \"],[10,0],[15,0,[28,[37,3],[\"tCW--radioBtn\",[30,3,[\"qaClass\"]],[52,[30,4],\"is--selected\"],[52,[30,0,[\"isFormDisabled\"]],\"is--disabled\"]],null]],[12],[1,\"\\n            \"],[11,\"input\"],[16,\"checked\",[30,4]],[16,\"disabled\",[30,0,[\"isFormDisabled\"]]],[16,1,[30,3,[\"value\"]]],[24,3,\"tone\"],[16,2,[30,3,[\"value\"]]],[24,4,\"radio\"],[4,[38,12],[\"click\",[28,[37,13],[[30,0,[\"onSelectTone\"]],[30,3]],null]],null],[12],[13],[1,\"\\n            \"],[10,\"label\"],[15,\"for\",[30,3,[\"value\"]]],[12],[1,\"\\n              \"],[1,[28,[35,14],[[30,3,[\"icon\"]]],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n              \"],[10,1],[12],[1,\"\\n                \"],[1,[30,3,[\"label\"]]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[1,[28,[35,14],[\"verified-solid\"],[[\"class\"],[\"o--icon o--icon--hl\"]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[4]]]],[3]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isCustomToneSelected\"]],[[[1,\"    \"],[8,[39,15],[[16,0,[28,[37,3],[\"o--form__input\",\"tCW--form__input\",\"qa--aiCaptions_tone_txtBox\",[52,[30,0,[\"toneValidationError\"]],\"has--error qa--error_border\"]],null]],[24,\"data-test-id\",\"caption-writer-form-custom-tone-input\"],[16,\"disabled\",[30,0,[\"isFormDisabled\"]]],[24,1,\"customTone\"],[24,3,\"customTone\"],[16,\"placeholder\",[28,[37,1],[\"caption_writer.form.tone_placeholder\"],null]],[4,[38,5],null,null]],[[\"@value\"],[[30,2,[\"tone\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"toneValidationError\"]],[[[1,\"      \"],[10,2],[14,0,\"tCW--form__helperText--error qa--error_inline_warning qa--error_border\"],[14,\"data-test-id\",\"caption-writer-form-custom-tone-input-error\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[30,0,[\"toneValidationError\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n  \"],[8,[39,16],[[24,\"data-test-id\",\"caption-writer-form-submit\"],[24,4,\"submit\"]],[[\"@additional\",\"@class\",\"@isDisabled\"],[\"rounded\",[28,[37,3],[\"o--btn--block\",\"u--m__t__md\",\"qa--aiCaptions_createBtn\",[52,[30,0,[\"isSubmitButtonDisabled\"]],\"qa--aiCaptions_createBtn_disabled\"]],null],[30,0,[\"isSubmitButtonDisabled\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[10,1],[14,0,\"u--m__r__xs\"],[12],[1,[28,[35,1],[\"caption_writer.button_cta\"],null]],[13],[1,\"\\n    \"],[1,[28,[35,14],[\"ai\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@skipTopic\",\"@generatedCaptionChangeset\",\"tone\",\"isSelected\"],false,[\"unless\",\"t\",\"textarea\",\"concat-classes\",\"if\",\"autofocus\",\"autoresize\",\"each\",\"-track-array\",\"let\",\"and\",\"eq\",\"on\",\"fn\",\"svg-jar\",\"input\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/form.hbs",
    "isStrictMode": false
  });
  const TOPIC = 'topic';
  const TONE = 'tone';
  let FormComponent = _exports.default = (_class = (_generateCaptions = /*#__PURE__*/new WeakSet(), _clearForm = /*#__PURE__*/new WeakSet(), class FormComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _clearForm);
      _classPrivateMethodInitSpec(this, _generateCaptions);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "selectedTone", _descriptor2, this);
      _defineProperty(this, "tones", void 0);
      this.tones = [{
        icon: 'tone-casual',
        value: _constants.CaptionWriterTone.Casual,
        label: this.intl.t('caption_writer.form.tones.casual'),
        qaClass: 'qa--aiCaptions_casualToneOptional_Btn'
      }, {
        icon: 'tone-professional',
        value: _constants.CaptionWriterTone.Professional,
        label: this.intl.t('caption_writer.form.tones.professional'),
        qaClass: 'qa--aiCaptions_professionalToneOptional_Btn'
      }, {
        icon: 'tones',
        value: _constants.CaptionWriterTone.Custom,
        label: this.intl.t('caption_writer.form.tones.custom'),
        qaClass: 'qa--aiCaptions_customToneOptional_Btn'
      }];
    }
    get isSubmitButtonDisabled() {
      return this.isFormInvalid || this.isFormDisabled || !this.args.generatedCaptionChangeset.topic || this.isCustomToneSelected && !this.args.generatedCaptionChangeset.tone ||
      // Note: hack for when changing tone via existing caption path
      this.args.skipTopic && !this.args.generatedCaptionChangeset.tone;
    }
    get isFormDisabled() {
      return this.args.isGeneratingCaptions || this.args.disabled;
    }
    get isFormInvalid() {
      return !this.args.generatedCaptionChangeset.isValid;
    }
    get isCustomToneSelected() {
      return this.selectedTone?.value === _constants.CaptionWriterTone.Custom;
    }
    get topicValidationError() {
      if (this.args.skipTopic) {
        return;
      }
      const {
        topic
      } = this.args.generatedCaptionChangeset;
      if (topic.length > 160) {
        return 'caption_writer.validations.length';
      }
      const topicErrors = this.args.generatedCaptionChangeset.errors?.filter(error => error.key === TOPIC);
      return topicErrors?.firstObject?.validation?.[0];
    }
    get toneValidationError() {
      const toneErrors = this.args.generatedCaptionChangeset.errors?.filter(error => error.key === TONE);
      return toneErrors?.firstObject?.validation?.[0];
    }
    onSelectTone(tone) {
      // Note: clicking the same tone will deselect it
      if (this.selectedTone?.value === tone.value) {
        this.selectedTone = undefined;
        this.args.generatedCaptionChangeset.tone = undefined;
        return;
      }
      this.selectedTone = tone;
      if (tone.value === _constants.CaptionWriterTone.Custom) {
        this.args.generatedCaptionChangeset.tone = undefined;
      } else {
        this.args.generatedCaptionChangeset.tone = tone.value;
      }
    }
    async onSubmitForm(event) {
      event.preventDefault();
      await _classPrivateMethodGet(this, _generateCaptions, _generateCaptions2).call(this);
      _classPrivateMethodGet(this, _clearForm, _clearForm2).call(this);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedTone", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "onSelectTone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectTone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmitForm", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmitForm"), _class.prototype)), _class);
  async function _generateCaptions2() {
    if (this.isSubmitButtonDisabled || this.isFormInvalid) {
      return;
    }
    await this.args.generateCaptions.perform();
  }
  function _clearForm2() {
    this.args.generatedCaptionChangeset.rollback();
    this.selectedTone = undefined;
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FormComponent);
});